import {BreakpointsOptions} from '@mui/system/createTheme/createBreakpoints';

import {Tokens} from '../../../types/generated/Tokens';

export const breakpoints = (breakpointsTokens: Tokens['breakpoints']): BreakpointsOptions => ({
  values: {
    xs: 0,
    sm: parseInt(breakpointsTokens.narrowTablet, 10),
    md: parseInt(breakpointsTokens.tablet, 10),
    lg: parseInt(breakpointsTokens.desktop, 10),
    xl: parseInt(breakpointsTokens.desktopHd, 10)
  }
});
